module.exports = __webpack_public_path__ + "img/trunk_3x4_z18.a4dd7eb6.svg";